import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
import util from "@/mixins/util";

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            linkType:0,
            display:0,
            linkUrl:'',
            linkBoardKey:'',
            seq:0,
            files:[],
            linkImageUrl: '',
            linkImageBoardKey: 0,
        }
    },
    validators: {
        linkType: function (value) {
            return Validator.value(value)
                .required('이동 타입을 선택해주세요.')
        },
        display: function (value) {
            return Validator.value(value)
                .required('노출 유무을 선택해주세요.')
        },

        linkImageUrl: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.linkType ==='url') {
                        if (util.isEmpty(value)) {
                            return '외부링크를 입력해주세요.'
                        } else if (!util.form.VTypes.url(value)) {
                            return '올바른 주소를 입력해 주세요'
                        }
                    }
                })
        },
        linkUrl: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.linkType ===1) {
                        if (util.isEmpty(value)) {
                            return '외부링크를 입력해주세요.'
                        } else if (!util.form.VTypes.url(value)) {
                            return '올바른 주소를 입력해 주세요'
                        }
                    }
                })
        },

        linkImageBoardKey : function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.linkType === 'notice' && util.isEmpty(value)) {
                        return '이동할 공지사항을 선택해주세요.'
                    }else if(this.linkType === 'event' && util.isEmpty(value)) {
                        return '이동할 이벤트를 선택해주세요.'
                    }
                })
        },

        linkBoardKey : function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.linkType ===2 && util.isEmpty(value)) {
                        return '이동할 공지사항을 선택해주세요.'
                    }else if(this.linkType ===3 && util.isEmpty(value)) {
                        return '이동할 이벤트를 선택해주세요.'
                    }
                })
        },


        seq : function (value) {
            return Validator.value(value)
                .required('노출 순서를 입력해주세요.')
                .integer('노출 순서는 숫자만 입력해주세요.')
        },
        files: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(util.isEmpty(value)) {
                        return '배너 이미지를 등록해주세요.'
                    }
                })
        },
    }
}
